<template>
    <div class="d-flex">
        <v-col
            class="col-6 px-0 py-0 line-liff-detail"
            v-for="tab in tabs"
            :key="tab.name">
            <div
                class="list-menu"
                :class="{ active: active === tab.name }"
                @click="clickItem(tab.name)">
                {{ tab.label }}
            </div>
        </v-col>
    </div>
</template>
<script>
export default {
    name: 'HeaderHistory',

    data () {
        return {
            active: null,
            tabs: [{
                name: 'history-attendance',
                label: this.$vuetify.lang.t('$vuetify.HistoryAttendance.tab.attendance')
            }, {
                name: 'history-quota',
                label: this.$vuetify.lang.t('$vuetify.HistoryAttendance.tab.quota')
            }]
        }
    },

    methods: {
        clickItem (name) {
            if (name !== this.$route.name) {
                this.$router.push({ name })
            }
        }
    },

    mounted () {
        this.active = this.$route.name
    }
}
</script>

<style lang="scss" scoped>
@import "@/styles/color.scss";
.list-menu {
    color: $base-grey4;
    background: #f4f4f4;
    border-bottom: 3px solid #f4f4f4;
    text-align: center;
    padding: 10px 5px;

    &.active {
        background: #f7e0d6;
        color: $base-orange;
        border-bottom: 3px solid $base-orange;
        opacity: 1;
        pointer-events: none;
    }
}
</style>
